import React, { useContext, useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import { getServiceFilterParams } from '@/pages/dashboard/utils/utils';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { getDefaultUtcDateValue } from '@/pages/dashboard/utils/dateUtils';

const NewUserService = (props: any) => {
  const { children, api, refreshKey = '', interval, metrics, ...resetProps } = props || {};
  const contextObj = useContext(FilterContext);
  const { filterVal, filterLoading } = contextObj || {};
  const gameCode = useSelector((state: any) => state?.dashboard?.currentGame?.game_code, shallowEqual);

  const data = useMemo(() => ({
    game_code: gameCode,
    metrics,
  }), [gameCode, metrics]);

  return (
    <Service
      api={api}
      data={data}
      refreshKey={refreshKey}
      interval={interval}
      dataKey={'data'}
      beforeRequest={(data) => {
        const { filterVal, game_code, metrics } = data;
        const defaultTimeRange = getDefaultUtcDateValue(filterVal?.timeType, filterVal?.rangeTime);
        const filterParams = getServiceFilterParams(
          filterVal,
          defaultTimeRange,
        );
        const params = {
          game_code,
          metrics,
          is_show_only_value: true,
          ...filterParams,
        };
        return params;
      }}
      trackData={['game_code', 'metrics']}
      formatData={(data) => {
        // 数据格式转化
        const dauList: any[] = [];
        data?.forEach((item: any) => {
          const obj: any = {
            date: item.date,
          };
          let total = 0;
          Object.keys(item?.metrics).forEach((key) => {
            obj[key] = item?.metrics[key]?.value;
            total += Number(item?.metrics[key]?.value);
          });
          obj.total = total;
          dauList.push(obj);
        });
        return {
          dau_breakdown: dauList,
          dau_breakdown_total: dauList.length,
        };
      }}
    >
      {
        // 保证是jsx数组，而不是其他类型数组
        React.Children.map(children, (child: any) => React.cloneElement(child, {
          ...resetProps,
          filterVal,
          filterLoading,
        }))
      }
    </Service>
  );
};

export default NewUserService;
